import { useSelector } from 'react-redux';
import { Redirect, Route, RouteChildrenProps, Switch } from 'react-router';
import { PageLayout } from '@rossum/components/page-layout/PageLayout';
import { Stack } from '@rossum/ui/material';
import { isDevFeatureEnabled } from '../../constants/dev';
import { userSelector } from '../../redux/modules/user/selectors';
import { ChangeFeatureFlagsPage } from './pages/ChangeFeatureFlagsPage';
import { DiscoveryCallSurveysPage } from './pages/DiscoveryCallSurveysPage';
import { PersonalSettingsPage } from './pages/PersonalSettingsPage';
import { RossumLabsPage, useVisibleLabFeatures } from './pages/RossumLabsPage';
import { PersonalSettingsHeader } from './PersonalSettingsHeader';

export const PersonalSettings = ({
  match,
}: RouteChildrenProps<{ section: string }>) => {
  const user = useSelector(userSelector);
  const visibleLabFeatures = useVisibleLabFeatures(user);

  if (!match) {
    return null;
  }

  const basePath = match.path.replace('/:section', '');

  return (
    <Switch>
      <PageLayout
        renderHeader={params => (
          <PersonalSettingsHeader
            user={user}
            tabsVisibility={{
              rossumLabs: !!visibleLabFeatures.length,
              changeFeatureFlags: !!isDevFeatureEnabled('feature-flags'),
              discoveryCallSurveys: !!isDevFeatureEnabled('discovery-calls'),
            }}
            {...params}
          />
        )}
      >
        <Stack spacing={3} data-page-title="personalSettings" p={4} flex={1}>
          <Switch>
            <Route
              path={`${basePath}/personalInfo`}
              component={PersonalSettingsPage}
            />

            {!!visibleLabFeatures.length && (
              <Route path={`${basePath}/rossumLabs`}>
                <RossumLabsPage
                  visibleLabFeatures={visibleLabFeatures}
                  user={user}
                />
              </Route>
            )}

            {isDevFeatureEnabled('feature-flags') && (
              <Route path={`${basePath}/changeFeatureFlags`}>
                <ChangeFeatureFlagsPage user={user} />
              </Route>
            )}

            {isDevFeatureEnabled('discovery-calls') && (
              <Route
                path={`${basePath}/discoveryCallSurveys`}
                component={DiscoveryCallSurveysPage}
              />
            )}
            <Redirect to={`${basePath}/personalInfo`} />
          </Switch>
        </Stack>
      </PageLayout>
    </Switch>
  );
};
